import React, { useState } from "react";
import "../../styles/report.css";

export default function ReportDocumentView({ html, onClose }) {

  // ✅ HOOKS MUST BE AT TOP (NO CONDITIONS BEFORE THIS)
  const [shareLink, setShareLink] = useState("");
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [loadingShare, setLoadingShare] = useState(false);

  // ⛔ Now only after hooks we can use conditions
  if (!html) return null;

  // ===============================
  // ⬇ DOWNLOAD PDF
  // ===============================
  const handleDownload = async () => {
    try {
      const response = await fetch("https://suryojasvi-reflection-api.wyzmindz.com/api/reports/download-pdf", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ html })
      });

      if (!response.ok) throw new Error("Server error");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Employee_Report.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("❌ PDF download failed");
      console.error("Download error:", error);
    }
  };

  // ===============================
  // 🔗 GENERATE SHARE LINK
  // ===============================
  const handleShare = async () => {
    try {
      setLoadingShare(true);

      const response = await fetch("https://suryojasvi-reflection-api.wyzmindz.com/api/reports/generate-share-link", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          html: html,
          employee: localStorage.getItem("email") || "Unknown",
          period: "Weekly / Monthly"
        })
      });

      if (!response.ok) throw new Error("Share link generation failed");

      const data = await response.json();
      setShareLink(data.share_link);
      setShowSharePopup(true);

    } catch (error) {
      alert("❌ Share link generation failed");
      console.error("Share error:", error);
    } finally {
      setLoadingShare(false);
    }
  };

  // ===============================
  // 📋 COPY LINK
  // ===============================
  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    alert("✅ Link copied!");
  };

  return (
    <div className="doc-overlay">
      <div className="doc-container">

        {/* ❌ CLOSE */}
        <button className="doc-close" onClick={onClose}>✖</button>

        {/* ⬇ DOWNLOAD */}
        <button className="doc-download" onClick={handleDownload}>
          ⬇ Download PDF
        </button>

        {/* 🔗 SHARE */}
        <button
          className="doc-share"
          onClick={handleShare}
          disabled={loadingShare}
        >
          🔗 {loadingShare ? "Generating..." : "Share"}
        </button>

        {/* 📄 DOCUMENT VIEW */}
        <div className="doc-paper-wrapper">
          <div className="doc-paper">
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>

        {/* 🔗 SHARE POPUP */}
        {showSharePopup && (
          <div className="share-popup">
            <h4>🔗 Share this link</h4>

            <div className="share-box">
              <input
                type="text"
                value={shareLink}
                readOnly
                onClick={(e) => e.target.select()}
              />
              <button onClick={handleCopy}>Copy</button>
            </div>

            <button
              className="share-close-btn"
              onClick={() => setShowSharePopup(false)}
            >
              Close
            </button>
          </div>
        )}

      </div>
    </div>
  );
}
